import { useSite } from "@/context/SiteContext";

export const TestimonialsSection = ({ content }) => {
  const { testimonials } = useSite();
  if (!testimonials.length) return null;

  return (
    <section className="py-16 bg-muted border-y border-border" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {content.eyebrow && (
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-primary mb-2">{content.eyebrow}</p>
        )}
        <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-foreground mb-8">
          {content.heading}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <figure key={t.id} className="bg-card border border-border rounded-md p-6" data-testid={`testimonial-${t.id}`}>
              <blockquote className="text-sm text-foreground leading-relaxed mb-5">"{t.quote}"</blockquote>
              <figcaption>
                <p className="font-display font-bold text-foreground uppercase">{t.name}</p>
                {t.role && <p className="text-xs text-muted-foreground">{t.role}</p>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
